import {createListFromObject, getTextByValue} from "../../../../Utilities/Types/listUtilities";

export const APH_QUEUE_STATUS = {
    Pending: 1,
    InReview: 2,
}

export const APH_QUEUE_STATUS_LIST = createListFromObject(APH_QUEUE_STATUS);


export const getAphQueueStatusTextByValue = (value: string | number = "") => getTextByValue(APH_QUEUE_STATUS_LIST, value);
